import { render, staticRenderFns } from "./RuleSummaryRow.vue?vue&type=template&id=44ec6097&scoped=true&"
import script from "./RuleSummaryRow.vue?vue&type=script&lang=js&"
export * from "./RuleSummaryRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ec6097",
  null
  
)

export default component.exports